"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apis = void 0;
class Apis {
}
exports.Apis = Apis;
